/*
 * Module for the response editor
 */

define([
  "marionette",
  "messaging/messenger",
  "./responseEditorModalView",
  "./responseEditorModalModel",
  "modules/shared/ckeditor5/ckEditor5Module",
], function (
  Marionette,
  Messenger,
  ResponseEditorModalView,
  ResponseEditorModalModel,
  Es6CkEditor5Module,
) {
  "use strict";

  const CkEditor5Module = Es6CkEditor5Module.default || Es6CkEditor5Module;

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "responseEditorModal";
      this._setUpVents();
    },
    show: function (conversationObject) {
      const responseEditorModalModel = new ResponseEditorModalModel.responseEditorModal({
        touchPointId: conversationObject.selectedTouchPoint,
        localeId: conversationObject.selectedLocale,
        conversationVariable: conversationObject.conversationVariable,
        response: "",
      });
      this.model = responseEditorModalModel;

      this._setResponse(conversationObject, responseEditorModalModel);

      this.dataChanged = false;
      this.view = new ResponseEditorModalView.responseEditorModalView({
        model: responseEditorModalModel,
      });

      this.view.on("done", () => {
        this._updateResponse(conversationObject, responseEditorModalModel);
        // rerender the response preview
        conversationObject.conversationVariable.trigger("change:prompt");
        Messenger.vent.trigger("close:modal");
      });

      this.view.on("cancel", () => {
        //ignore any changes to the response
        Messenger.vent.trigger("close:modal");
      });

      this.htmlEditor = this.addSubModule(
        new CkEditor5Module.ckEditor5Module({ namespace: this.name, region: this.view.htmlEditor }),
      );

      this.view.on("show", () => {
        this.htmlEditor.show({
          languageId: responseEditorModalModel.get("localeId"),
          touchPointId: responseEditorModalModel.get("touchPointId"),
          responseId: responseEditorModalModel.get("conversationVariable").get("responseId"),
          response: responseEditorModalModel.get("response"),
          skipAttributes: true,
          skipCategories: true,
          skipCollaborationFeatures: true,
          skipConversationVariables: true,
          skipOpenSnippetEditor: true,
          skipSnippets: true,
        });
      });

      this.showRegion(this.view);
    },
    _setResponse: function (conversationObject, model) {
      const touchPointId = model.get("touchPointId");
      const localeId = model.get("localeId");
      conversationObject.conversationVariable.getResponse(touchPointId, localeId, (responseText) =>
        model.set("response", responseText),
      );
    },
    _setUpVents: function () {
      Messenger.vent.on(Messenger.getFullName("ckeditor:initializeError", this.name), () =>
        Messenger.vent.trigger("close:modal"),
      );
    },
    _updateResponse: function (conversationObject, model) {
      // Only update if the CKEditor actually has changes.  Cannot just compare with what we currently have,
      // because the CKEditor does some modification of the HTML to "sanitize" it.
      if (this.htmlEditor.isDirty()) {
        const newResponse = this.htmlEditor.getResponse();
        conversationObject.conversationVariable.setResponse(
          model.get("touchPointId"),
          model.get("localeId"),
          newResponse,
        );
      }
    },
  });
});
